import { forwardRef, Icon, IconProps } from '@chakra-ui/react';

const Push = forwardRef<IconProps, 'svg'>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8 1.37866L4.46446 4.9142L5.52512 5.97486L7.25 4.24998V10.128C6.3761 10.4369 5.75 11.2703 5.75 12.25C5.75 13.4926 6.75736 14.5 8 14.5C9.24264 14.5 10.25 13.4926 10.25 12.25C10.25 11.2703 9.62389 10.4369 8.75 10.128V4.24998L10.4749 5.97486L11.5355 4.9142L8 1.37866ZM8 13C8.41421 13 8.75 12.6642 8.75 12.25C8.75 11.8358 8.41421 11.5 8 11.5C7.58578 11.5 7.25 11.8358 7.25 12.25C7.25 12.6642 7.58578 13 8 13Z"
      fill="currentColor"
    />
  </Icon>
));

export default Push;
